const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInuseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6797"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 157546",
    style: {
      fill: "none"
    },
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.958-838.619a10.845 10.845 0 0 1-4.971-3.908 10.422 10.422 0 0 1-1.935-6.195 11.876 11.876 0 0 1 .11-1.622 9.031 9.031 0 0 1 .359-1.564l-1.9 1.1-.849-1.482 4.968-2.866 2.86 4.956-1.5.871-1.636-2.838a8.122 8.122 0 0 0-.517 1.677 9.34 9.34 0 0 0-.169 1.781 8.826 8.826 0 0 0 1.679 5.274 9.026 9.026 0 0 0 4.367 3.307zm7.823-14.134v-1.72h3.268A8.982 8.982 0 0 0 37.878-857a9.022 9.022 0 0 0-3.945-.892 8.867 8.867 0 0 0-3.191.57 9.129 9.129 0 0 0-2.69 1.591l-.871-1.521a11.291 11.291 0 0 1 3.108-1.731 10.439 10.439 0 0 1 3.633-.628 10.732 10.732 0 0 1 4.284.873 10.71 10.71 0 0 1 3.587 2.522v-2.271h1.72v5.732zm-.293 17.143-4.968-2.877 2.866-4.939 1.482.86-1.711 2.93a8.919 8.919 0 0 0 5.66-3.045 8.873 8.873 0 0 0 2.267-6.048 8.039 8.039 0 0 0-.047-.885 5.7 5.7 0 0 0-.16-.846h1.759q.084.419.126.84t.042.88a10.566 10.566 0 0 1-2.33 6.746 10.56 10.56 0 0 1-5.994 3.816l1.868 1.087z",
    transform: "translate(-16.77 863.61)",
    style: {
      fill: "#527ff2"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInuseIcon);
export default __webpack_public_path__ + "static/media/inuse_icon.92746715972cbab718c341a6956e173c.svg";
export { ForwardRef as ReactComponent };